import firebase from "firebase";
import Vue from 'vue'
import Router from 'vue-router'
import routes from "./routes";

Vue.use(Router)

const router = new Router({
   routes: routes
})

router.beforeEach((to, from, next) => {
   const currentUser = firebase.auth().currentUser
   const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

   if (requiresAuth && !currentUser) {
      next({ name: 'login' })
   } else if (!requiresAuth && currentUser) {
      next({ name: 'welcome' })
   } else {
      next()
   }
})

export default router;
